import Vue from 'vue'
import Element from 'element-ui'
import './element/theme/index.css'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(Element, { locale })
